/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from '@reduxjs/toolkit';
import { makeAsyncSelectors } from 'ui-lottery';
import facilities, { selectors as facilitiesSelectors } from './facilities';
import passTypes, { selectors as passTypesSelectors } from './passTypes';
import passType, { selectors as passTypeSelectors } from './passType';
import facility, { selectors as facilitySelectors } from './facility';
import facilityByIdOrSlug, {
    selectors as facilityByIdOrSlugSelectors,
} from './facilityByIdOrSlug';
import reservations, { selectors as reservationsSelectors } from './reservations';
import { reducer as validation, selectors as validationSelectors } from './validation';

// Generate the async selectors
const { isLoaded, isLoading, hasErrors, getErrors } = makeAsyncSelectors('activitypass');

// All of our Redux selectors
export {
    facilitiesSelectors,
    getErrors,
    hasErrors,
    isLoaded,
    isLoading,
    passTypeSelectors,
    passTypesSelectors,
    validationSelectors,
    facilitySelectors,
    facilityByIdOrSlugSelectors,
    reservationsSelectors,
};

const reducers = combineReducers({
    facilities,
    facility,
    passType,
    passTypes,
    validation,
    facilityByIdOrSlug,
    reservations,
});

export default reducers;
